import React from "react";
import ExportModal from "../../../../Components/Export/ExportModal";

export interface TransactionExportItem {
  id: string;
  type: string;
  amount: number;
  description: string;
  date: Date;
  employee: string;
  category: string;
}

const COLUMN_KEYS = ["category", "type", "amount", "description", "date", "employee"] as const;
const COLUMN_LABELS: Record<string, string> = {
  category: "Category",
  type: "Type",
  amount: "Amount",
  description: "Description",
  date: "Date",
  employee: "Employee/Agent",
};

/**
 * Custom processor: readable headers, selected columns only, date formatted as string.
 */
function transactionsDataProcessor(
  data: TransactionExportItem[] | null | undefined,
  selectedColumns: string[]
): string[][] {
  if (!data || !Array.isArray(data)) return [];
  if (selectedColumns.length === 0) return [];

  const headerRow = selectedColumns.map((col) => COLUMN_LABELS[col] ?? col);
  const dataRows = data.map((item) =>
    selectedColumns.map((col) => {
      const value = (item as unknown as Record<string, unknown>)[col];
      if (value === undefined || value === null) return "";
      if (value instanceof Date) return value.toLocaleDateString();
      if (typeof value === "number") return String(value);
      return String(value);
    })
  );
  return [headerRow, ...dataRows];
}

export interface TransactionsExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: TransactionExportItem[];
}

const TransactionsExportModal: React.FC<TransactionsExportModalProps> = ({
  isOpen,
  onClose,
  data,
}) => {
  return (
    <ExportModal
      isOpen={isOpen}
      onClose={onClose}
      data={data}
      filename="transactions_export"
      title="Export Transactions"
      columns={[...COLUMN_KEYS]}
      customDataProcessor={transactionsDataProcessor}
    />
  );
};

export default TransactionsExportModal;
